import { getRealMusclePoint } from "./index5.js";
import { hasBoneAt } from "./index20.js";
import { hasCornerCore } from "./index22.js";
import { BoneSide, GetAllBones, RG_TYPE } from "@project-rouge/rg-core";
import { Line3, Vector3 } from "three";
var _vector3 = new Vector3();
const ResizeTendonsToMuscles = (building, corridorWidth, useGrid) => {
	const bones = GetAllBones(building.data.anatomy);
	for (const b of bones) {
		if (b.muscles.length === 0) continue;
		setTendonPoint(b, 0, corridorWidth, useGrid);
		setTendonPoint(b, 1, corridorWidth, useGrid);
	}
};
var boneLine = new Line3();
var boneVector = new Vector3();
function boneToLine(bone) {
	boneLine.start.fromArray(bone.joints[0].pos);
	boneLine.end.fromArray(bone.joints[1].pos);
	return boneLine;
}
function setTendonPoint(bone, pointIndex, corridorWidth, useGrid) {
	const iA = pointIndex;
	const iB = pointIndex ? 0 : 1;
	const sign = pointIndex ? -1 : 1;
	const fn = pointIndex ? Math.max : Math.min;
	boneToLine(bone);
	boneLine.delta(boneVector);
	const boneLength = boneVector.length();
	let alpha = iA;
	if (useGrid && hasBoneAt({
		bone,
		right: !pointIndex,
		start: !pointIndex,
		outerLoad: true
	})) alpha = iA + sign * (corridorWidth * .5 / boneLength);
	else if (hasCornerCore(bone.joints[iA]) && bone.loads.some((load) => !load)) alpha = iA + corridorWidth * .5 / boneLength;
	else {
		const leftMuscle = bone.muscles.find((m) => m.side === BoneSide.Left);
		const rightMuscle = bone.muscles.find((m) => m.side === BoneSide.Right);
		const hasLeftMuscle = leftMuscle && leftMuscle.gFUnits.length > 0;
		const hasRightMuscle = rightMuscle && rightMuscle.gFUnits.length > 0;
		const leftAlpha = !hasLeftMuscle ? NaN : boneLine.closestPointToPointParameter(getRealMusclePoint(leftMuscle, iB));
		const rightAlpha = !hasRightMuscle ? NaN : boneLine.closestPointToPointParameter(getRealMusclePoint(rightMuscle, iA));
		const leftClose = !hasLeftMuscle ? NaN : getCloseLength(leftMuscle, iB);
		const rightClose = !hasRightMuscle ? NaN : getCloseLength(rightMuscle, iA);
		if (isNaN(leftAlpha)) alpha = rightAlpha;
		else if (isNaN(rightAlpha)) alpha = leftAlpha;
		else alpha = fn(leftAlpha, rightAlpha);
		if (leftClose) alpha = leftAlpha + sign * leftClose / boneLength;
		else if (rightClose) alpha = rightAlpha + sign * rightClose / boneLength;
	}
	bone.tendon.points[pointIndex] = _vector3.lerpVectors(boneLine.start, boneLine.end, alpha).toArray();
}
function getCloseLength(muscle, pointIndex) {
	const unit = muscle.gFUnits.at(!pointIndex ? 0 : muscle.gFUnits.length - 1);
	if (!unit) return 0;
	if (unit.type !== RG_TYPE.Apartment) return 0;
	const apartment = unit;
	if (!apartment.data.closeDirection) return 0;
	if (pointIndex === 0 && apartment.data.closeDirection[0] > 0) return apartment.data.closeLength;
	if (pointIndex === 1 && apartment.data.closeDirection[0] < 0) return apartment.data.closeLength;
	return 0;
}
export { ResizeTendonsToMuscles };

//# sourceMappingURL=index26.js.map